function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconOutlink2 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 15 15"
}, props), /*#__PURE__*/React.createElement("g", {
  "data-name": "\\uBE7C\\uAE30 2",
  style: {
    fill: "none"
  }
}, /*#__PURE__*/React.createElement("path", {
  d: "M12 12H0v-1h11V0h1z",
  style: {
    stroke: "none"
  },
  transform: "translate(3 3)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12 12H0v-1h11V0h1z",
  style: {
    fill: "#333",
    stroke: "none"
  },
  transform: "translate(3 3)"
})), /*#__PURE__*/React.createElement("g", {
  "data-name": "\\uC0AC\\uAC01\\uD615 109",
  style: {
    stroke: "#333",
    fill: "none"
  }
}, /*#__PURE__*/React.createElement("path", {
  stroke: "none",
  d: "M0 0h12v12H0z",
  style: {
    stroke: "none"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M.5.5h11v11H.5z",
  style: {
    fill: "none"
  }
})));
export default SvgIconOutlink2;